import { ChangeDetectionStrategy, Component, forwardRef, input, viewChild } from '@angular/core';

import {FieldOkComponent} from '@softline/dynamic';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DefaultFieldOkConfiguration} from '../field-ok-configuration';
import {FieldOkWrapper} from '../field-ok-wrapper';

@Component({
    selector: 'soft-vertreter-field-ok',
    imports: [FieldOkComponent],
    templateUrl: './vertreter-field-ok.component.html',
    styleUrl: './vertreter-field-ok.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VertreterFieldOkComponent),
            multi: true,
        },
    ]
})
export class VertreterFieldOkComponent extends FieldOkWrapper<DefaultFieldOkConfiguration> implements ControlValueAccessor {
  readonly fieldOkComponent = viewChild.required(FieldOkComponent);
  override value = input<object | null>(null);
  override configuration = input<DefaultFieldOkConfiguration | null>(null);
  override parameters = input<object>({});
  override readonly = input<boolean>(false);
}
